import React, { useMemo } from 'react';
import PromotionBlockedModal from '../components/Modal/Promotions/PromotionBlockedModal';
import useGetIp from './useGetIp';

function useGetIsPromotionDisabled(
  blacklistedCountries,
  blacklistedCountriesProviders,
) {
  const { data: country } = useGetIp();

  const userCountry = useMemo(() => (country ?? '').trim().toUpperCase(), [country]);

  const isPromotionDisabled = useMemo(() => {
    if (!userCountry) return false;

    const toCodeList = (v) => {
      if (Array.isArray(v)) return v;
      if (typeof v === 'string') {
        return v
          .split(/[,\s;]+/)
          .map(s => s.trim())
          .filter(Boolean);
      }
      return [];
    };

    const merged = new Set(
      [...toCodeList(blacklistedCountries), ...toCodeList(blacklistedCountriesProviders)]
        .map(c => c.toUpperCase())
        .filter(Boolean),
    );

    return merged.has(userCountry);
  }, [userCountry, blacklistedCountries, blacklistedCountriesProviders]);

  if (isPromotionDisabled) {
    return <PromotionBlockedModal />;
  }

  return null;
}

export default useGetIsPromotionDisabled;
